import React, { PropsWithChildren } from 'react';
import { Flex, Button } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { Link } from 'react-router-dom';

interface Props {
	link?: string | null;
	linkLabel?: string;
	linkDataTestId?: string;
}

export const ExpandedListContainer = ({
	children,
	link,
	linkLabel,
	linkDataTestId,
}: PropsWithChildren<Props>) => (
	<Flex direction="column" align="start" w="100%">
		<Flex direction="column" gap="0.25rem" w="100%">
			{children}
		</Flex>
		{link && linkLabel && (
			<Link to={link} data-testid={linkDataTestId} onClick={(e) => e.stopPropagation()}>
				<Button
					variant="transparent"
					c="blue.6"
					p="0"
					mih="2rem"
					rightSection={
						<Icon variant="arrow-right" size="lg" style={{ marginLeft: '0.5rem' }} />
					}
				>
					{linkLabel}
				</Button>
			</Link>
		)}
	</Flex>
);
